import { Query } from "../generated/nest-graphql";
import { GET_MARKETS } from "../graphql/queries/getMarkets";
import { useQuery } from "@apollo/client";
import { propOr } from "ramda";

export const useMarkets = () => {
  const { data } = useQuery<Query, {}>(GET_MARKETS);
  return propOr(null, "getMarketsV2", data);
};
